module.exports = __webpack_public_path__ + "images/no-triggers-1a1efc26.svg";